/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerGenerateDescriptionFromDataMutationRequest,
  TelegramProductsUserControllerGenerateDescriptionFromDataMutationResponse,
  TelegramProductsUserControllerGenerateDescriptionFromData400,
  TelegramProductsUserControllerGenerateDescriptionFromData401,
  TelegramProductsUserControllerGenerateDescriptionFromData404,
} from '../types/TelegramProductsUserControllerGenerateDescriptionFromData.ts';

function getTelegramProductsUserGenerateDescriptionFromDataUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/products/description-generation` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/description-generation}
 */
export async function telegramProductsUserGenerateDescriptionFromData(
  data: TelegramProductsUserControllerGenerateDescriptionFromDataMutationRequest,
  config: Partial<RequestConfig<TelegramProductsUserControllerGenerateDescriptionFromDataMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramProductsUserControllerGenerateDescriptionFromDataMutationResponse,
    ResponseErrorConfig<
      | TelegramProductsUserControllerGenerateDescriptionFromData400
      | TelegramProductsUserControllerGenerateDescriptionFromData401
      | TelegramProductsUserControllerGenerateDescriptionFromData404
    >,
    TelegramProductsUserControllerGenerateDescriptionFromDataMutationRequest
  >({
    method: 'POST',
    url: getTelegramProductsUserGenerateDescriptionFromDataUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
